import React from 'react';
import { Checkbox, DropDownMenu } from '@shape-ds/components';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

export const FREQUENCY_OPTIONS = [
  'DAILY',
  'MONDAYS',
  'TUESDAYS',
  'WEDNESDAYS',
  'THURSDAYS',
  'FRIDAYS',
  'SATURDAYS',
];
export const DEFAULT_FREQUENCY = [FREQUENCY_OPTIONS[0]];

const NotificationFrequencyOptions: React.FC<{ fieldName?: string; onClickAway: () => void }> = ({
  fieldName = 'frequency',
  onClickAway,
}) => {
  const { setValue, watch } = useFormContext();
  const frequency: string[] = watch(fieldName, [FREQUENCY_OPTIONS[0]]);
  const { t } = useTranslation();

  const onChangeFrequency = (item: string) => {
    const shouldRemoveDaily = item !== 'DAILY' && frequency.includes('DAILY');

    const newValues = frequency.includes(item)
      ? frequency.filter((i: string) => i !== item)
      : [...frequency, item];

    if (shouldRemoveDaily) {
      setValue(
        fieldName,
        newValues.filter((f: string) => f !== 'DAILY'),
      );
      return;
    }
    const shouldSetDaily = item === 'DAILY' && !frequency.includes('DAILY');
    const shouldSetDefault = newValues.length === 0;
    if (shouldSetDaily || shouldSetDefault) {
      setValue(fieldName, ['DAILY']);
      return;
    }

    setValue(fieldName, newValues);
  };
  const frequencyOptions = FREQUENCY_OPTIONS.map((item) => (
    <Checkbox
      key={item}
      label={t(`components:notifications_manager.frequency_options.${item}`)}
      checked={frequency.includes(item)}
      onChange={() => onChangeFrequency(item)}
    />
  ));
  return (
    <DropDownMenu
      dropDownOptions={[]}
      className="notification-frequency-dropdown"
      customOptions={frequencyOptions}
      onClickAway={onClickAway}
      title="Frequency:"
      dividerIndex={0}
    />
  );
};

export default NotificationFrequencyOptions;
